// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3AG4E","header":"PatientQuestionnaire_header__2lJFw","info":"PatientQuestionnaire_info__Xo0nc"};